module.exports = __webpack_public_path__ + "img/Group 1-3.4e7a132b.png";